<template>
  <app-card variant="muted">
    <app-collapse is-open>
      <template #heading>
        <div class="flex gap-3">
          <agency-payable-icon
            size="sm"
            :status="payable ? PayableStatus.PAYABLE : PayableStatus.NOT_PAYABLE"
            not-payable-icon="link-broken-two"
          />
          <div class="space-y-0.5">
            <p class="font-semibold">{{ listTitle.label }}</p>
            <p class="text-xs">({{ listTitle.linkedText }})</p>
          </div>
        </div>
      </template>

      <div class="space-y-4">
        <agency-identifier-display-label
          v-for="(identifier, idx) in identifiers"
          :key="idx"
          :count="idx + 1"
          :identifier="identifier"
        />
      </div>
    </app-collapse>
  </app-card>
</template>

<script setup>
import { computed } from 'vue';
import { PayableStatus } from '@/constants/payableStatus';
import AgencyPayableIcon from '@/components/agencies/AgencyPayableIcon.vue';
import AgencyIdentifierDisplayLabel from '@/components/agencies/AgencyIdentifierDisplayLabel.vue';

const props = defineProps({
  identifiers: {
    type: Array,
    default: () => [],
  },
  payable: {
    type: Boolean,
    default: false,
  },
});

const listTitle = computed(() => {
  if (props.payable) {
    return {
      label: 'Payable Identifiers',
      linkedText: 'Linked to a beneficiary',
    };
  } else {
    return {
      label: 'Not payable Identifiers',
      linkedText: 'No beneficiary linked',
    };
  }
});
</script>
